const objFunc = () => {
  return {
    isMarried: undefined,
    spousesName: '',
    spousesAddress: {}
  }
}

export default objFunc()

export const defaultObj = objFunc()
